/* select "tariff" — форма "Оставьте заявку" (_FormTguHome.cshtml),
   select "tariff-program" — форма в hero (FormHero.cshtml) */
const TARIFF_SELECT_IDS = ["tariff", "tariff-program"];
const CTA_SELECTOR = ".tariffs__cta[data-tariff]";

/* Клик по кнопке "Записаться" в блоке тарифов должен сразу проставлять
   выбранный тариф во всех формах заявки на странице программы */
function setupTariffPreselect() {
  const selects = TARIFF_SELECT_IDS.map((id) => document.getElementById(id)).filter(Boolean);

  if (!selects.length) return;

  document.querySelectorAll(CTA_SELECTOR).forEach((cta) => {
    cta.addEventListener("click", () => {
      selects.forEach((select) => $(select).val(cta.dataset.tariff).trigger("change"));
    });
  });
}

export { setupTariffPreselect };
